
export default function BoltOwnCode({data}) {
  return (
    <>
      <section className="lyft-support-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <div className="lyft-support-box">
                <img loading="lazy" src={data && data.box1.image} alt="Icon" className="img-responsive" />
                <small>{data && data.box1.title}</small>
              </div>
            </div>

            <div className="col-lg-3 col-md-3">
              <div className="lyft-support-box">
                <img loading="lazy" src={data && data.box2.image} alt="Icon" className="img-responsive" />
                <small>{data && data.box2.title}</small>
              </div>
            </div>

            <div className="col-lg-3 col-md-3">
              <div className="lyft-support-box">
                <img loading="lazy" src={data && data.box3.image} alt="Icon" className="img-responsive" />
                <small>{data && data.box3.title}</small>
              </div>
            </div>

            <div className="col-lg-3 col-md-3">
              <div className="lyft-support-box">
                <img loading="lazy" src={data && data.box4.image} alt="Icon" className="img-responsive" />
                <small>{data && data.box4.title}</small>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
